export default __webpack_public_path__ + "static/Educational-6154b9e4a322f9ad24ecf718d0d9e45b.jpg";